<template>
  <el-container>
    <el-header>
      <common-header/>
    </el-header>
    <div class="banner banner2">
      <div class="maincontainer">
        <div class="icon"></div>
        <div class="title">{{ $t('lang.applyList.applyRecord') }}</div>
      </div>
    </div>
    <div class="searchbox">
      <div class="maincontainer">
        <el-form ref="form" :model="searchParams" :label-width="isZh ? '100px' : '150px'" size="mini"
                 :disabled="!isLogin">
          <el-row :gutter="30">
            <el-col :span="6">
              <el-form-item :label="$t('lang.applyList.applyNo')">
                <el-input v-model="searchParams.applyNo"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('lang.applyList.applyStatus')">
                <el-select v-model="searchParams.applyStatus" :placeholder="$t('lang.common.pleaseSelect')">
                  <el-option :label="$t('lang.applyList.applyStatusOptions.all')" :value="null"></el-option>
                  <el-option :label="$t('lang.applyList.applyStatusOptions.draft')" value="DRAFT"></el-option>
                  <el-option :label="$t('lang.applyList.applyStatusOptions.toBePaid')" value="TO_BE_PAID"></el-option>
                  <el-option :label="$t('lang.applyList.applyStatusOptions.certBeingIssued')"
                             value="CERT_BEING_ISSUED"></el-option>
                  <el-option :label="$t('lang.applyList.applyStatusOptions.certIssued')"
                             value="CERT_ISSUED"></el-option>
                  <el-option :label="$t('lang.applyList.applyStatusOptions.partlyReceived')"
                             value="PARTLY_RECEIVED"></el-option>
                  <el-option :label="$t('lang.applyList.applyStatusOptions.finished')" value="FINISHED"></el-option>
                  <el-option :label="$t('lang.applyList.applyStatusOptions.cancelled')" value="CANCELLED"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item :label="$t('lang.applyList.applyType')">
                <el-select v-model="searchParams.applyType" :placeholder="$t('lang.common.pleaseSelect')">
                  <el-option :label="$t('lang.applyList.applyTypeOptions.all')" :value="null"></el-option>
                  <el-option :label="$t('lang.applyList.applyTypeOptions.paper')" value="PAPER"></el-option>
                  <el-option :label="$t('lang.applyList.applyTypeOptions.electronic')" value="ELECTRONIC"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="text-align:right">
              <el-button
                @click="query"
                type="ceibsprimary"
                style="
                  border-radius: 20px;
                  padding-left: 30px;
                  padding-right: 30px;
                  margin-right:20px">
                {{ $t('lang.common.query') }}
              </el-button>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>
    <el-main>
      <div class="maincontainer" style="padding: 20px 0">
        <div style="padding:0 20px">
          <el-table
            :data="tableData"
            stripe
            size="small"
            :cell-style="{ textAlign: 'center' }"
            :header-cell-style="{
            background: '#7b7b7b',
            color: '#ffffff',
            textAlign: 'center',
            fontWeight: 'normal',
          }"
            style="width: 100%"
          >
            <el-table-column prop="applyNo"
                             :label="$t('lang.applyList.columns.applyNo')"
                             width="140"></el-table-column>
            <el-table-column prop="applyTime"
                             :label="$t('lang.applyList.columns.applyTime')"
                             :formatter="formatters.applyTime"
                             width="140"></el-table-column>
            <el-table-column prop="applyType"
                             :label="$t('lang.applyList.columns.applyType')"
                             :formatter="formatters.applyType"
                             class-name="red"
                             width="90"></el-table-column>
            <el-table-column prop="chargeAmount"
                             :formatter="formatters.chargeAmount"
                             :label="$t('lang.applyList.columns.chargeAmount')"
                             width="90"></el-table-column>
            <el-table-column prop="applyStatus"
                             :formatter="formatters.applyStatus"
                             :label="$t('lang.applyList.columns.applyStatus')"
                             class-name="red"
                             width="90"></el-table-column>
            <el-table-column prop="payType"
                             :label="$t('lang.applyList.columns.payType')"
                             :formatter="formatters.payType"
                             width="120">
            </el-table-column>
            <el-table-column prop="payStatus"
                             :label="$t('lang.applyList.columns.payStatus')"
                             class-name="red"
                             :formatter="formatters.payStatus"
                             width="120"></el-table-column>
            <el-table-column :label="$t('lang.applyList.columns.operation')">
              <template slot-scope="scope">
                <div style="text-align:center">
                  <!--                  <el-button size="mini"-->
                  <!--                             v-if="scope.row.payType === 'BANK_TRANSFER' && scope.row.payStatus === 'TO_BE_CONFIRMED' && scope.row.applyStatus === 'TO_BE_PAID'"-->
                  <!--                             type="text"-->
                  <!--                             @click="openUploadBankTransferVoucherDialog(scope.row)">-->
                  <!--                    {{ $t('lang.applyList.operations.uploadBankTransferVoucher') }}-->
                  <!--                    <i class="icon iconfont icon-xiangshangjiantou-s"></i>-->
                  <!--                  </el-button>-->
                  <el-button size="mini"
                             v-if="scope.row.payStatus === 'TO_BE_CONFIRMED' && scope.row.applyStatus === 'TO_BE_PAID'"
                             type="text"
                             @click="openPayDialog(scope.row)">
                    {{ $t('lang.applyList.operations.startOnlinePay') }}
                    <i class="icon iconfont icon-meiyuan"></i>
                  </el-button>
                  <el-button size="mini"
                             v-if="scope.row.applyStatus === 'DRAFT'"
                             type="text"
                             @click="continueApply(scope.row)">
                    {{ $t('lang.applyList.operations.continueApply') }}
                    <i class="icon iconfont icon-xuanze"></i>
                  </el-button>
                  <el-button size="mini"
                             v-if="scope.row.applyStatus === 'DRAFT'"
                             type="text"
                             @click="cancelApply(scope.row)">
                    {{ $t('lang.applyList.operations.cancelApply') }}
                    <i class="icon iconfont icon-guanbi"></i>
                  </el-button>
                  <el-button size="mini"
                             v-if="scope.row.applyType === 'ELECTRONIC' && (scope.row.applyStatus === 'CERT_ISSUED' || scope.row.applyStatus === 'FINISHED')"
                             type="text"
                             @click="openElectronicApplyDetailDialog(scope.row)">
                    {{ $t('lang.applyList.operations.downloadElectronicVersionFile') }}
                    <i class="icon iconfont icon-xiangxiajiantou-s"></i>
                  </el-button>
                  <el-button size="mini"
                             type="text"
                             v-if="scope.row.applyStatus !== 'CANCELLED' && scope.row.applyStatus !== 'DRAFT'"
                             @click="checkDetail(scope.row)">
                    {{ $t('lang.applyList.operations.checkDetail') }}
                    <i class="icon iconfont icon-xiangyoujiantou-s"></i>
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="width:100%;padding:20px 0; text-align:right">
          <el-pagination
            background
            layout="prev, pager, next,total"
            @current-change="handleCurrentPageChange"
            :current-page="pagination.currentPage"
            :page-size="pagination.pageSize"
            :total="pagination.totalSize">
          </el-pagination>
        </div>
      </div>
    </el-main>

    <pay-dialog :visible.sync="payDialog.visible" :apply-vo="payDialog.apply" @submit="loadApplyList"></pay-dialog>
    <el-dialog
      custom-class="ceibsdialog"
      width="650px"
      :visible.sync="electronicApplyDetailVisible"
      :before-close="closeElectronicApplyDetailDialog"
      :center="true">
      <div slot="title" style="color: #a2100e;">{{
          $t('lang.applyList.operations.downloadElectronicVersionFile')
        }}
      </div>
      <electronic-apply-detail :apply-vo="electronicApplyDetailApplyVo"></electronic-apply-detail>
      <electronic-receipt-file :apply-vo="electronicApplyDetailApplyVo"
                               v-if="electronicApplyDetailApplyVo.needReceipt === 'Y'"></electronic-receipt-file>
      <!--      <div class="electronic-receipt-wrapper" >
              <div class="receipt-title">{{ $t('lang.applyList.electronicReceiptFile') }}</div>
              <el-row class="receipt-row-header">
                <el-col :span="12">{{ $t('lang.applyList.receiptTitle') }}</el-col>
                <el-col :span="12">{{ $t('lang.applyList.receiptFileName') }}</el-col>
              </el-row>
              <el-row class="receipt-row-content">
                <el-col :span="12">{{ electronicApplyDetailApplyVo.receiptTitle }}</el-col>
                <el-col :span="12">
                  <el-button type="info"
                             size="mini"
                           v-if="electronicApplyDetailApplyVo.scannedReceiptFile"
                           @click="downloadReceipt">
                    {{
                      electronicApplyDetailApplyVo.scannedReceiptFile.fileName
                    }}
                    <i class="icon iconfont icon-xiangxiajiantou-s" style="color: #a2100e"></i>
                  </el-button>
                  <template v-else>
                    {{ $t('lang.applyList.receiptFileNotUpload') }}
                  </template>
                </el-col>
              </el-row>
            </div>-->
    </el-dialog>
  </el-container>
</template>

<script>
import CommonHeader from '@/components/common/commonHeader'
import { mapGetters } from 'vuex'
import { config } from '@/util/common.config'
import { cancel, find, list } from '@/api/apply'
import { formatDate } from '@/util/util.date'
import languageType from '@/locales/languageType'
import ElectronicApplyDetail from '@/views/apply/record/component/electronicApplyDetail'
import PayDialog from '@/views/apply/record/component/payDialog'
import { getAccessToken, getRefreshToken } from '@/util/util.ruquest'
import { downloadFile } from '@/api/base'
import ElectronicReceiptFile from '@/views/apply/record/component/ElectronicReceiptFile'

export default {
  name: 'applyList',
  components: { ElectronicReceiptFile, PayDialog, ElectronicApplyDetail, CommonHeader },
  data () {
    return {
      electronicApplyDetailVisible: false,
      electronicApplyDetailApplyVo: {},
      uploadBankTransferVoucher: {
        visible: false,
        apply: null
      },
      payDialog: {
        visible: false,
        apply: null
      },
      searchParams: {
        applyNo: null,
        applyStatus: null,
        applyType: null,
        id: null
      },
      pagination: {
        currentPage: config.currentPage,
        pageSize: config.pageSize,
        totalSize: 0
      },
      tableData: [],
      payPlatformDto: null,
      formatters: {
        applyTime: (row, column, cellValue) => {
          return formatDate(cellValue)
        },
        applyType: (row, column, cellValue) => {
          let val = ''
          if (cellValue === 'PAPER') {
            val = this.$t('lang.applyList.applyTypeOptions.paper')
          } else if (cellValue === 'ELECTRONIC') {
            val = this.$t('lang.applyList.applyTypeOptions.electronic')
          }
          return val
        },
        chargeAmount: (row, column, cellValue) => {
          return cellValue != null && row.chargeCurrency ? (row.chargeCurrency === 'RMB' ? '￥' : '$') + cellValue.toFixed(2) : ''
        },
        applyStatus: (row, column, cellValue) => {
          let val = ''
          if (cellValue === 'DRAFT') {
            val = this.$t('lang.applyList.applyStatusOptions.draft')
          } else if (cellValue === 'TO_BE_PAID') {
            val = this.$t('lang.applyList.applyStatusOptions.toBePaid')
          } else if (cellValue === 'CERT_BEING_ISSUED') {
            val = this.$t('lang.applyList.applyStatusOptions.certBeingIssued')
          } else if (cellValue === 'CERT_ISSUED') {
            if (row.issuedQty > 0) {
              val = this.$t('lang.applyList.applyStatusOptions.certIssued')
            } else {
              val = this.$t('lang.applyList.applyStatusOptions.notIssued')
            }
          } else if (cellValue === 'PARTLY_RECEIVED') {
            val = this.$t('lang.applyList.applyStatusOptions.partlyReceived')
          } else if (cellValue === 'FINISHED') {
            val = this.$t('lang.applyList.applyStatusOptions.finished')
          } else if (cellValue === 'CANCELLED') {
            val = this.$t('lang.applyList.applyStatusOptions.cancelled')
          }
          return val
        },
        payType: (row, column, cellValue) => {
          let val = ''
          if (cellValue === 'CASH') {
            val = this.$t('lang.applyList.payType.cash')
          } else if (cellValue === 'BANK_TRANSFER') {
            val = this.$t('lang.applyList.payType.bankTransfer')
          } else if (cellValue === 'ONLINE') {
            val = this.$t('lang.applyList.payType.online')
          }
          return val
        },
        payStatus: (row, column, cellValue) => {
          let val = ''
          if (cellValue === 'NO_NEED_CONFIRM') {
            val = this.$t('lang.applyList.payStatus.noNeedConfirm')
          } else if (cellValue === 'TO_BE_CONFIRMED') {
            val = this.$t('lang.applyList.payStatus.toBeConfirmed')
          } else if (cellValue === 'PAID') {
            val = this.$t('lang.applyList.payStatus.paid')
          } else if (cellValue === 'FAILED') {
            val = this.$t('lang.applyList.payStatus.failed')
          }
          return val
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'currentApplyId',
      'currentLanguage',
      'quickQueryApplyId'
    ]),
    isZh: function () {
      return this.currentLanguage === languageType.zh.code
    },
    isLogin: function () {
      return getAccessToken() && getRefreshToken()
    }
  },
  mounted () {
    if (!this.isLogin && !this.currentApplyId && !this.quickQueryApplyId) {
      this.$router.push('/')
    }
    if (this.$route.params.uploadVoucherApplyId) {
      this.initBankTransferDialog(this.$route.params.uploadVoucherApplyId)
    }
    if (this.quickQueryApplyId) {
      this.searchParams.id = this.quickQueryApplyId
    }
    this.loadApplyList()
  },
  methods: {
    goto (url) {
      this.$router.push(url)
    },
    loadApplyList () {
      list({
        ...this.searchParams,
        currentPage: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      }).then(res => {
        this.pagination.totalSize = res.data.total
        this.tableData = res.data.records
      })
    },
    handleCurrentPageChange (val) {
      this.pagination.currentPage = val
      this.loadApplyList()
    },
    query () {
      this.pagination.currentPage = 1
      this.loadApplyList()
    },
    continueApply (apply) {
      find({
        id: apply.id
      }).then(res => {
        const applyVo = res.data
        this.$store.dispatch('setCurrentApplyId', applyVo.id)
        if (!applyVo.packVoList) {
          // 无包装信息，去确认个人信息
          this.goto('confirmInfo')
        } else {
          // 有包装信息，去装袋页
          this.goto('confirmPack')
        }
      })
    },
    cancelApply (apply) {
      this.$confirm(this.$t('lang.applyList.confirmCancelApply'), this.$t('lang.common.warning'), {
        type: 'warning',
        confirmButtonClass: 'el-button--ceibsprimary',
        cancelButtonClass: 'el-button--ceibs'
      }).then(() => {
        cancel({
          id: apply.id,
          lockVersion: apply.lockVersion
        }).then(res => {
          this.$message.success(this.$t('lang.toast.operationSuccess'))
          this.loadApplyList()
        })
      })
    },
    checkDetail (apply) {
      this.$router.push({
        path: '/applyDetail',
        query: {
          id: apply.id
        }
      })
    },
    initBankTransferDialog (applyId) {
      find({
        id: applyId
      }).then(res => {
        this.openPayDialog(res.data)
      })
    },
    openElectronicApplyDetailDialog (apply) {
      find({
        id: apply.id
      }).then(res => {
        this.electronicApplyDetailApplyVo = res.data
        this.electronicApplyDetailVisible = true
      })
    },
    closeElectronicApplyDetailDialog () {
      this.electronicApplyDetailVisible = false
      this.loadApplyList()
    },
    openPayDialog (apply) {
      this.payDialog.visible = true
      this.payDialog.apply = apply
    },
    downloadReceipt () {
      downloadFile(this.electronicApplyDetailApplyVo.scannedReceiptFile)
    }
  }
}
</script>

<style scoped>
.searchbox {
  background: #f0f0f0;
  padding: 15px 0;
}

/deep/ .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
  margin-bottom: 0;
}

/deep/ .el-form-item__label {
  color: #a2100e;
}

/deep/ .searchbox .el-input__inner {
  background-color: #dddee2;
}

/deep/ .el-table td.red .cell {
  color: #a2100e;
}

/deep/ .el-pagination.is-background .el-pager li {
  background-color: #7c7c7c;
  color: #fff;
  border-radius: 100%;
  font-size: 12px;
  min-width: 23px;
  height: 23px;
  line-height: 23px;
}

/deep/ .el-pagination.is-background .btn-prev, .el-pagination.is-background .btn-next {
  background-color: unset;
}

/deep/ .el-pagination.is-background .btn-next {
  background-color: unset;
}

/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #a2100e;
}

/deep/ .el-pagination.is-background .el-pager li:hover {
  color: #ffffff;
}

/deep/ .el-button--text {
  color: #606266;
}

/deep/ .el-button--text i {
  color: #a2100e;
  margin-left: 5px;
  font-size: 18px;

}

/deep/ .el-button--text span {
  display: flex;
  align-items: center;
}

.electronic-receipt-wrapper {
  margin-top: 20px;
  text-align: center;
}

.receipt-title {
  background: #a2100e;
  color: #fff;
  text-align: center;
  height: 35px;
  line-height: 35px;
  box-shadow: -1px 3px 11px 2px rgb(136 136 136 / 51%);
}

.receipt-row-header {
  font-size: 12px;
  color: #a2100e;
  padding: 10px 0 5px 0;
}
</style>
